import { computed } from 'vue'

import { useStore } from '@/store'
import Page from '@/models/Page'
import Stage from '@/models/Stage'
import Artist from '@/models/Artist'
import News from '@/models/News'

export const useContent = () => {
  const store = useStore()

  const pages = computed<Page[]>(() => {
    return store.stories.filter((story: any) => story.type === 'page').filter((s) => s.title) || []
  })

  const stages = computed<Stage[]>(() => {
    return store.stories.filter((story: any) => story.type === 'stage').filter((s) => s.title) || []
  })

  const artists = computed<Artist[]>(() => {
    return (
      store.stories.filter((story: any) => story.type === 'artist').filter((s) => s.title) || []
    )
  })

  const news = computed<News[]>(() => {
    return store.stories.filter((story: any) => story.type === 'news').filter((s) => s.title) || []
  })

  const getStoryByUuid = (uuid: string) => {
    return store.stories.find((story: any) => story.uuid === uuid) || null
  }

  return {
    news,
    pages,
    stages,
    artists,
    getStoryByUuid,
  }
}
